import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import ar from './locales/ar.json';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: en,    // your default “translation” namespace
        navbar: en.navbar,  // load navbar keys under a separate namespace
      },
      ar: {
        translation: ar,
        navbar: ar.navbar,
      }
    },
    fallbackLng: 'en',
    lng: 'en',
    ns: ['translation','navbar'],  // <-- make sure both namespaces are declared
    defaultNS: 'translation',
    interpolation: { escapeValue: false }
  });

export default i18n;
